import { every, match } from 'components/Shared/Form';

const isValidZipcodeFormatSweden = match(/^\d{3}\s\d{2}$|^\d{5}$/);

export const ZIP_CODE_LENGTH = 5;

export const isValidZipcode = every(isValidZipcodeFormatSweden);

/**
 * Returns a formatted zip code from input.
 *
 * Example: So that UI can show whitespaces in Zip Code but the code still needs it without whitespaces.
 *
 * @param zipCode Given Zip Code
 * @returns Formatted Zip Code
 */
export const getFormattedZipCode = (zipCode: string): string => {
  const notNumbersRegex = /\D/g;
  return zipCode.replaceAll(notNumbersRegex, '');
};
